window.tasksModule.directive "tMedication", ['$log', ($log) ->
  restrict: "E"
  scope:
    task: '='
  link: (scope, element, attrs) ->
    scope.$log = $log.getInstance('tMedication directive', true, false, true)
    scope.$log.log 'tMedication'

  templateUrl: 'portal/tasks/tasks/t-medication/t-medication-directive-template.html'
]